import { render, staticRenderFns } from "./DatosGeneralesTab.vue?vue&type=template&id=790030b1&scoped=true&lang=pug"
import script from "./DatosGeneralesTab.vue?vue&type=script&lang=js"
export * from "./DatosGeneralesTab.vue?vue&type=script&lang=js"
import style0 from "./DatosGeneralesTab.vue?vue&type=style&index=0&id=790030b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790030b1",
  null
  
)

export default component.exports